module.exports = __webpack_public_path__ + "fonts/Inter-ExtraLightItalic.54d3d9a.woff2";